export default __webpack_public_path__ + "static/media/XS4 Original.94be2245.jpg";